import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import type { RestaurantRoomPax } from '@/models/restaurant-manager'
import { formatRoomOccupancy } from '@/utils/format-room-occupancy'

type Props = {
  rooms: RestaurantRoomPax[]
}

export const RestaurantRoomNumberCell: React.FC<Props> = ({ rooms }) => {
  const { t } = useTranslation()

  if (rooms.length === 0) {
    return <>-</>
  }

  return (
    <div css={roomListStyle}>
      {rooms.map((room, index) => (
        <div key={`${room.roomNumber}-${index}`} css={roomBlockStyle}>
          <div css={roomNumberTextStyle}>{room.roomNumber}</div>
          <div css={roomOccupancyTextStyle}>{formatRoomOccupancy(room, t)}</div>
        </div>
      ))}
    </div>
  )
}

const roomListStyle = css({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  width: '100%',
  gap: 2,
})

const roomBlockStyle = css({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minWidth: 0,
})

const roomNumberTextStyle = css({
  fontWeight: 'bold',
  lineHeight: 1.3,
  fontSize: 14,
})

const roomOccupancyTextStyle = css({
  color: '#676767',
  fontSize: 11,
  lineHeight: 1.2,
})
